<script setup lang="ts">
import { useContact } from '~/composables/useContact'

const { contactInfo } = useContact()
const { getMapsUrl } = useMaps()

const busLines = [
  { 
    line: 'A', 
    to: 'St-Jean', 
    stop: 'Arrêt Pompidor' 
  },
  { 
    line: 'D', 
    to: 'Crabit', 
    stop: 'Arrêt Naïade' 
  }
]
</script>

<template>
  <div class="w-full rounded-2xl overflow-hidden bg-oxo-card-bg border border-oxo-border shadow-2xl">
    <!-- Red Header Bar -->
    <div class="bg-oxo-red py-3 px-6 text-center">
      <h2 class="text-white font-black text-lg md:text-xl uppercase tracking-[0.2em]">
        Venez nous rencontrer !
      </h2>
    </div>

    <!-- Content -->
    <div class="p-8 md:p-12">
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16">
        
        <!-- Locaux -->
        <div class="flex flex-col gap-6">
          <div class="flex items-center gap-3">
            <div class="w-8 h-8 rounded-lg bg-oxo-yellow/20 flex items-center justify-center text-oxo-yellow">
              <i class="fas fa-building" aria-hidden="true"></i>
            </div>
            <h3 class="font-bold text-xl text-white">Locaux</h3>
          </div>
          
          <div class="space-y-4">
            <a 
              v-if="contactInfo.address"
              :href="getMapsUrl(contactInfo.address, 'OXO')"
              target="_blank"
              rel="noopener noreferrer"
              class="text-foreground-dim text-lg leading-relaxed hover:text-oxo-red transition-colors"
            >
              {{ contactInfo.address }}
            </a>
            
            <div class="inline-flex items-center gap-3 px-4 py-2 rounded-xl bg-green-500/10 border border-green-500/20 text-green-700 dark:text-green-500">
              <i class="fas fa-check-square text-sm" aria-hidden="true"></i>
              <span class="text-sm font-bold">Accessible aux personnes à mobilité réduite</span>
              <i class="fas fa-wheelchair text-lg opacity-80" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <!-- Bus -->
        <div class="flex flex-col gap-6">
          <div class="flex items-center gap-3">
            <div class="w-8 h-8 rounded-lg bg-blue-500/20 flex items-center justify-center text-blue-500">
              <i class="fas fa-bus" aria-hidden="true"></i>
            </div>
            <h3 class="font-bold text-xl text-white">Bus</h3>
          </div>

          <div class="flex flex-col gap-4">
            <div 
              v-for="line in busLines" 
              :key="line.line"
              class="flex items-center justify-between p-4 rounded-xl border border-oxo-border bg-background/50 group hover:border-oxo-red/50 transition-colors"
            >
              <div class="flex items-center gap-3">
                <span class="font-black text-white">Ligne {{ line.line }}</span>
                <span class="text-foreground-dim">→</span>
                <span class="font-bold text-white">{{ line.to }}.</span>
              </div>
              <div class="flex items-center gap-2 text-xs text-foreground-dim italic">
                <i class="fas fa-map-pin text-oxo-red" aria-hidden="true"></i>
                <span>{{ line.stop }}</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
